





































































































































import Vue from 'vue'
import { tssp, assp, ws } from '../service'
import ArgTabPane from './ArgTabPane.vue'
import AlarmTabPane from './AlarmTabPane.vue'
import SelectWorkstation from './SelectWorkstation.vue'
import { transformLocalToRemote } from '../utils'
import { getUserInfo } from '@/utils/auth'
import dayjs from 'dayjs'

export default Vue.extend({
  name: 'StatusCard',
  components: {
    ArgTabPane,
    AlarmTabPane,
    SelectWorkstation
  },
  props: ['record', 'statusDict'],
  data() {
    return {
      visible: false,
      submitLoading: false,
      tabPaneLoading: false,
      currentTab: 'alarm',
      // tagsList: [],
      // detail: null,
      alarmList: [],
      alarmLoading: false,
      properties: {},
      // statusKeys: [],
      status: '0',
      syncVisible: false,
      alarmListPagination: { current: 1, pageSize: 10, total: 0 }
    }
  },
  computed: {
    color() {
      const num = Number(this.status)
      if (num < 1 || num > 10) {
        return this.statusDict['0'].color
      }
      return this.statusDict[this.status].color
    },
    statusText() {
      const num = Number(this.status)
      if (num < 1 || num > 10) {
        return this.statusDict['0'].name
      }
      return this.statusDict[this.status].name
    },
    originalParams() {
      return this.record.workingConditionSettingVOList || []
    },
    detail() {
      return this.record.detail || null
    },
    tagsList() {
      return this.record.tagsList || []
    },
    statusKeys() {
      return this.record.statusKeys || []
    }
  },
  watch: {
    alarmListPagination: {
      async handler(val) {
        this.alarmLoading = true
        try {
          const res = await assp.alarmTodayDetail(val.current - 1, val.pageSize)
          this.alarmList = res.records
          this.alarmListPagination.total = Number(res.total)
        } finally {
          this.alarmLoading = false
        }
      }
    }
  },
  async created() {
    await this.$nextTick()
    ws.properties$$.subscribe((properties) => {
      if (!properties) return
      this.properties = properties
      for (let key in properties) {
        if (this.statusKeys.includes(key)) {
          this.status = properties[key]
        }
      }
    })
  },
  methods: {
    openSync() {
      console.log(this.record)
      this.syncVisible = true
    },
    syncClose() {
      this.syncVisible = false
    },
    reload() {
      this.$emit('refresh')
    },
    showAlarm(item) {
      const code = this.getProperty(item.iotId, item.iotAppId, item.iotAppParamDesc, item.unit).code
      return code && code !== '0' && code !== 'null'
    },
    getTenantId() {
      const info = getUserInfo()
      return info.tenant_id || ''
    },
    openSettingModal() {
      this.visible = true
      this.fetchAlarm()
    },
    async submit() {
      this.submitLoading = true
      const remoteArgsList = transformLocalToRemote(this.$refs.argTabPane.argsList)
      const body = {
        ...this.detail,
        paramName: 'workStation-property-setting',
        paramKey: this.record.id,
        paramValue: JSON.stringify(remoteArgsList)
        // paramValue: '',
      }
      try {
        await tssp.submit(body)
        this.visible = false
        this.$message.success(this.$i18n.t('page_mdc_realtime_success'))
      } finally {
        this.submitLoading = false
        this.$emit('refresh')
      }
    },
    async fetchAlarm() {
      this.alarmLoading = true
      try {
        const res = await assp.alarmRealDetail(
          this.alarmListPagination.current - 1,
          this.alarmListPagination.pageSize,
          this.record.id
        )
        this.alarmList = res.records.map((item, index) => ({
          ...item,
          id: item.alarmCode + item.alarmMsg + item.alarmTime + index
        }))
        this.alarmListPagination.total = Number(res.total)
      } finally {
        this.alarmLoading = false
      }
    },
    getProperty(iotId, iotAppId, iotAppParamDesc, unit, id) {
      const tenantId = this.getTenantId()
      let p = this.properties[`${tenantId}/${iotId}/${iotAppId}/${iotAppParamDesc}`]
      const u = unit === null ? '' : unit
      if (p) {
        if (p.includes('AlarmArray')) {
          p = JSON.parse(p)
          // p = p.AlarmArray.map(
          //   (item) => `${item.code}|${item.msg}|${dayjs(Number(item.timestamp)).format('YYYY-MM-DD HH:mm:ss')}`
          // )
          // 找出需要展示的报警信息， code为null '' 0 不展示
          let flag = false
          for (const res of p.AlarmArray) {
            if (res.code && res.code !== '0' && res.code !== 'null') {
              flag = true
              p = res
              break
            }
          }
          if (!flag) {
            p = p.AlarmArray[0]
          }
          p.timestamp = dayjs(Number(p.timestamp)).format('YYYY-MM-DD HH:mm:ss')
          if (p.timestamp === 'Invalid Date') p.timestamp = ''

          if (id.includes('code')) return p.code
          if (id.includes('info')) return p.msg
          if (id.includes('time')) return p.timestamp
          return p
        }
        if (p.includes('timestamp')) {
          p = JSON.parse(p)
          p.timestamp = dayjs(Number(p.timestamp)).format('YYYY-MM-DD HH:mm:ss')
          // p = `${p.code}|${p.msg}|${dayjs(Number(p.timestamp)).format('YYYY-MM-DD HH:mm:ss')}`
          if (p.timestamp === 'Invalid Date') p.timestamp = ''
          if (id.includes('code')) return p.code
          if (id.includes('info')) return p.msg
          if (id.includes('time')) return p.timestamp
          return p
        }
        return p + u
      } else {
        return ''
      }
    }
  }
})
